import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Dep } from '../../comm/class/auth';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit, OnChanges {
  @Input() loading: boolean;
  switchGIF: number;
  defaultLoadingType: number = 1; // 1: Happy Dance, 2: Icon loading
  private loadingStartTime: number = 0;
  showLoading: boolean = false;

  constructor() {
    const power = Dep.auth.power_id;
    this.switchGIF = power;
    
    if (power !== 5 && power !== 16) {
      // 從 localStorage 讀取儲存的 defaultLoadingType 值
      const savedLoadingType = localStorage.getItem('defaultLoadingType');
      this.defaultLoadingType = savedLoadingType ? parseInt(savedLoadingType) : 1;
    }
  }

  ngOnInit(): void {
    // console.log('use loadin');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.loading) {
      if (changes.loading.currentValue) {
        // 當 loading 變為 true 時
        this.loadingStartTime = Date.now();
        this.showLoading = true;
      } else if (changes.loading.currentValue === false) {
        // 當 loading 變為 false 時
        const currentTime = Date.now();
        const elapsedTime = currentTime - this.loadingStartTime;
        const minimumTime = 300; // 300ms 防閃爍(原為 2000ms 會多轉)

        if (elapsedTime < minimumTime) {
          // 如果還沒到 2 秒，等待剩餘時間
          setTimeout(() => {
            this.showLoading = false;
          }, minimumTime - elapsedTime);
        } else {
          // 如果已經超過 2 秒，直接關閉
          this.showLoading = false;
        }
      }
    }
  }

  // 檢查是否可以切換 GIF
  canSwitchGIF(): boolean {
    const power = Dep.auth.power_id;
    return power !== 5 && power !== 16;
  }

  // 切換預設 loading 動畫類型
  switchDefaultLoading() {
    if (this.canSwitchGIF()) {
      this.defaultLoadingType = this.defaultLoadingType === 1 ? 2 : 1;
      localStorage.setItem('defaultLoadingType', this.defaultLoadingType.toString());
    }
  }
} 
